import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type ApiVolume = {
	date: Date;
	total: number;
};

export type ApiVolumeApplication = {
	id: number;
	volumes: ApiVolume[];
};

export type GetDataSecurityApiVolumeRequest = DateRangeQueryParams & {
	applicationId?: number;
	stakeholderGroupId?: number;
};

export type GetDataSecurityApiVolumeResponse = Required<DateRangeQueryParams> & {
	applications: ApiVolumeApplication[];
};

export const getDataSecurityApiVolume = createGetEndpoint<
	GetDataSecurityApiVolumeRequest | undefined,
	GetDataSecurityApiVolumeResponse
>((request) => `/api/v3/data-security/organization/api-volume?${getQueryString(request)}`);
